import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PlayerModel } from '../../../core/models/app.models';
import { PlayerService } from '../../../core/services/player.service';
import { Subject, debounceTime, distinctUntilChanged, switchMap, of } from 'rxjs';

@Component({
  selector: 'app-player-select',
  template: `
    <p-dropdown [options]="players"
                [(ngModel)]="value"
                [showClear]="showClear"
                [filter]="true"
                [lazy]="true"
                (onFilter)="onSearch($event)"
                [placeholder]="placeholder"
                [styleClass]="styleClass"
                [style]="{'width': '100%'}"
                [loading]="loading"
                (onChange)="onChanged($event.value)"
                optionLabel="lastName"
                optionValue="id">
      <ng-template let-player pTemplate="item">
        <div class="flex flex-column">
          <span class="font-bold">{{ player.lastName }} {{ player.firstName }}</span>
          <small class="text-500" *ngIf="player.facrId">ID: {{ player.facrId }}</small>
        </div>
      </ng-template>
    </p-dropdown>
  `,
  styles: `
    :host {
      width: 100%
    }
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PlayerSelectComponent),
      multi: true
    }
  ]
})
export class PlayerSelectComponent implements OnInit, ControlValueAccessor {
  @Input() placeholder: string = 'Vyberte hráče';
  @Input() showClear: boolean = true;
  @Input() styleClass: string = '';

  players: PlayerModel[] = [];
  loading = false;
  private searchSubject = new Subject<string>();

  _value: any;

  constructor(private playerService: PlayerService) {}

  ngOnInit() {
    this.loadInitial();

    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(query => {
        if (!query || query.length < 2) return this.playerService.getAllSimple();
        this.loading = true;
        return this.playerService.searchPlayers(query);
      })
    ).subscribe(data => {
      this.players = data;
      this.loading = false;
      this.ensureSelectionInList();
    });
  }

  private loadInitial() {
    this.loading = true;
    this.playerService.getAllSimple().subscribe(data => {
      this.players = data;
      this.loading = false;
      this.ensureSelectionInList();
    });
  }

  onSearch(event: any) {
    this.searchSubject.next(event.filter);
  }

  private ensureSelectionInList() {
    if (this._value && !this.players.find(p => p.id === this._value)) {
      this.playerService.getById(this._value).subscribe(player => {
        if (player && !this.players.find(p => p.id === player.id)) {
          this.players = [player, ...this.players];
        }
      });
    }
  }

  get value() { return this._value; }
  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
    }
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void {
    this._value = value;
    if (value) this.ensureSelectionInList();
  }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }

  onChanged(val: any) {
    this.value = val;
  }
}
